import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { getDoc } from '../../services';
import MoreLikeThis from './MoreLikeThis';
import Loading from './Loading';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DOMPurify from 'dompurify';

library.add(fal);

const ReadMoreDoc = ({
  doc,
  profilePrimary,
  profileSecondary,
  list,
  allTags,
  updateTagSet,
  activeTags,
}) => {
  const [isReadMore, setIsReadMore] = useState(true);
  const [contents, setContents] = useState();
  const [contentsState, setContentsState] = useState(0);

  const toggleReadMore = async () => {
    setContents('');
    if (isReadMore) {
      setIsReadMore(false);
      setContentsState(1);
      //return;
      const result = await getDoc(
        doc.id,
        doc.repositoryId ?? null,
        profilePrimary
      );
      if (result && result.status === 200) {
        const sanitizedData = DOMPurify.sanitize(result.response);
        //const body = parse(converter.makeHtml(result.response));
        setContents(sanitizedData);
        setContentsState(2);
      } else {
        console.error('Failed to fetch document:', result);
        setContents('<span>Unable to fetch document.</span>');
        setContentsState(2);
      }
    } else {
      setIsReadMore(true);
      setContents('<span>Unable to fetch document.</span>');
      setContentsState(3);
    }
  };

  return (
    <section className='ctx-card-readmore aser'>
      <Button
        variant='text'
        onClick={toggleReadMore}
        className={
          isReadMore
            ? 'icon-only-button'
            : 'icon-only-button icon-only-button--open'
        }
        data-testid='expand-news-button'
      >
        <FontAwesomeIcon icon={['fal', 'caret-up']}></FontAwesomeIcon>
      </Button>
      {contentsState && contentsState !== 3 ? (
        <div className='ctx-readmore-wrapper'>
          {contentsState === 1 && <Loading text='Retrieving More...' />}
          <div className='ctx-readmore-contents'>
            {contents && (
              <div
                className='ctx-template'
                dangerouslySetInnerHTML={{
                  __html: contents.replace(/href/g, "target='_blank' href"),
                }}
              />
            )}
          </div>
          {profileSecondary && (
            <MoreLikeThis
              docId={doc.id}
              profilePrimary={profilePrimary}
              profileSecondary={profileSecondary}
              list={list}
            />
          )}
        </div>
      ) : null}
    </section>
  );
};

export default ReadMoreDoc;
